export type QuestionInputType =
  | 'text'
  | 'email'
  | 'tel'
  | 'date'
  | 'number'
  | 'textarea'
  | 'select'
  | 'choice'
  | 'multi'
  | 'consent';

export interface TournamentQuestion {
  id: number;
  question_text: string;
  question_type: QuestionInputType;
  options: string[];
  is_mandatory: boolean | number;
  validator_regex?: string;
  placeholder_text?: string;
  helper_text?: string;
  field_to_update?: string;
  rank: number;
}

export interface EligibilityCriterion {
  criterion: string;
  label: string;
  passed: boolean;
  value: string;
  hint?: string | null;
}

export interface CategoryEntry {
  key: string;
  label: string;
  value: number;
}

export enum RegistrationStage {
  INIT = 0,
  QUESTIONS = 1,
  ENTRY_FEE = 2,
  SERIES = 3,
  PAYMENT_STATUS = 4,
  NOT_ELIGIBLE = 5,
}
